(() => {
  const initSlider = (section) => {
    if (section.dataset.sliderReady === 'true') return;

    const track = section.querySelector('.bba-categories__track');
    const previous = section.querySelector('[data-bba-category-prev]');
    const next = section.querySelector('[data-bba-category-next]');
    if (!track || !previous || !next) return;

    section.dataset.sliderReady = 'true';

    const getStep = () => {
      const card = track.querySelector('.bba-category');
      if (!card) return track.clientWidth;
      const styles = window.getComputedStyle(track);
      return card.getBoundingClientRect().width + Number.parseFloat(styles.columnGap || styles.gap || 0);
    };

    const updateControls = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    };

    const move = (direction) => {
      track.scrollBy({ left: getStep() * direction, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      move(event.key === 'ArrowRight' ? 1 : -1);
    });

    let frame;
    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(updateControls);
    }, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();
  };

  const initAll = (root = document) => {
    if (root.matches?.('[data-bba-category-slider]')) initSlider(root);
    root.querySelectorAll('[data-bba-category-slider]').forEach(initSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
